/* Published phone schedule only; this is not a live staffing or pickup signal. */
(function () {
  'use strict';

  // Returns null when the date or time-zone service cannot be evaluated safely.
  function getPhoneSchedule(date, intlApi) {
    try {
      if (date === null || typeof date === 'boolean') return null;
      const instant = new Date(date);
      if (!Number.isFinite(instant.getTime())) return null;
      const api = intlApi === undefined ? Intl : intlApi;
      const parts = new api.DateTimeFormat('en-US', {
        timeZone: 'America/New_York', weekday: 'short', hour: 'numeric', hourCycle: 'h23'
      }).formatToParts(instant);
      const weekday = parts.find((part) => part.type === 'weekday')?.value;
      const hourText = parts.find((part) => part.type === 'hour')?.value;
      if (!['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].includes(weekday) ||
          !/^\d{1,2}$/.test(hourText || '')) return null;
      const hour = Number(hourText);
      if (hour < 0 || hour > 23) return null;
      const isWeekend = weekday === 'Sat' || weekday === 'Sun';
      const openingHour = isWeekend ? 8 : 9;
      const closingHour = isWeekend ? 20 : 21;
      return hour >= openingHour && hour < closingHour ? 'open' : 'closed';
    } catch (_) {
      return null;
    }
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = { getPhoneSchedule };
  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  function update() {
    const schedule = getPhoneSchedule(new Date());
    document.querySelectorAll('[data-ns-service-hours]').forEach((container) => {
      if (schedule === null) container.removeAttribute('data-ns-phone-schedule');
      else container.setAttribute('data-ns-phone-schedule', schedule);
      container.querySelectorAll('[data-ns-after-hours]').forEach((paragraph) => {
        paragraph.hidden = schedule !== 'closed';
      });
    });
  }

  update();
  document.addEventListener('DOMContentLoaded', update, { once: true });
  window.addEventListener('load', update, { once: true });
  window.setInterval(() => { if (!document.hidden) update(); }, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
})();
